import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import Image from 'next/image';

import AlertDialogPopUp from '@components/common/AlertDialogPopUp';
import PhoneInput from '@components/common/PhoneInput/PhoneInput';

import { formatPhoneNumber, isValidPhoneNumber } from '@utils';
import Link from 'next/link';

const styles = {
  confirmImage: {
    width: '100%',
    maxWidth: '300px',
    position: { xs: 'relative', md: 'absolute' },
    bottom: '-2px',
    right: '-15px',
    ml: { xs: '-20px', md: 0 },
    mt: { xs: 3, md: 0 },
  },
};
export default function PhoneNumberPopup({ handleClose, open, handleSubmit }) {
  const { t } = useTranslation(['common']);

  const [phone, setPhone] = useState('');

  const handlePhoneValueChange = (value) => {
    setPhone(value);
  };

  const handlePhoneValueSubmit = () => {
    const formattedPhone = formatPhoneNumber(phone);
    handleSubmit(formattedPhone);
  };

  return (
    open && (
      <AlertDialogPopUp
        open={open}
        onClose={handleClose}
        paperProps={{
          backgroundImage: "url('/assets/images/background/dialog-wave.svg')",
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
          width: '90%',
          maxWidth: '750px',
          minHeight: '370px',
          height: 'auto',
        }}
        dialogContentProps={{
          overflowy: 'unset',
        }}
        body={
          <Grid container item xs={12}>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography variant="subtitle2">
                  {t('phone_no_popup_title')}
                </Typography>
              </Box>
              <Box mt={6}>
                <PhoneInput
                  placeholder={t('enter_phone_no')}
                  id="phone"
                  onClick={handlePhoneValueSubmit}
                  onChange={handlePhoneValueChange}
                  value={phone}
                  disabled={!isValidPhoneNumber(phone)}
                />
              </Box>
            </Grid>
            <Grid>
              <Typography onClick={handleClose}>
                {t('accept_terms_statement1')}
                <Link href="/terms_of_use" passhref onClick={handleClose}>
                  {t('terms_of_use')}
                </Link>
                {t('and')}
                <Link href="/privacy_policy" passhref onClick={handleClose}>
                  {t('privacy_policy')}
                </Link>
              </Typography>
            </Grid>
            <Grid item container xs={12} md={6} justifyContent="center">
              <Box sx={styles.confirmImage}>
                <Image
                  src={'/assets/images/confirm.png'}
                  width="991"
                  height="1045"
                  layout="responsive"
                  alt="confirm"
                />
              </Box>
            </Grid>
          </Grid>
        }
      />
    )
  );
}
PhoneNumberPopup.defaultProps = {
  handleClose: () => {},
  handleSubmit: () => {},

  open: false,
};

PhoneNumberPopup.propTypes = {
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,

  open: PropTypes.bool,
};
